/**
 * Minimal locality coordinate lookup for the POC demo. A proper location model
 * with geocoding (G-NAF / NSW Point) arrives in Epic 4; for now the demo
 * scenario centres on Bungendore.
 */
export interface LngLat {
  lng: number;
  lat: number;
}

export const LOCALITIES: Record<string, LngLat> = {
  bungendore: { lng: 149.4434, lat: -35.2558 },
};

/** Default map centre for incidents without resolved coordinates (POC). */
export const DEFAULT_CENTER: LngLat = LOCALITIES.bungendore!;

/** Resolve a centre for an incident id (scenario-aware), else the default. */
export function centerForIncident(incidentId: string): LngLat {
  if (incidentId.includes('bungendore')) return LOCALITIES.bungendore!;
  return DEFAULT_CENTER;
}
